$(document).ready(function(){
  $('.template-product .gst-switch #toggle').prop("checked",true);
    // var price_type = Cookies.get('price_type');
      var price_type = 'Excl';
//   	console.log(price_type);
  	if(price_type == 'Incl'){
    	$('.template-product .gst-switch #toggle').prop("checked",true);
         $('.kg-excluding-price').hide();
         $('.kg-including-price').show();
  	
  	} else if(price_type == 'Excl') {
    	$('.template-product .gst-switch #toggle').prop("checked",false);
        $('.kg-excluding-price').show();
        $('.kg-including-price').hide();
  	}
 
});  
 $(document).on("change",".gst-switch #toggle",function() {
  
    	if($(this).is(':checked') == true){
          $('.template-product .gst-switch #toggle').prop("checked",true);
            Cookies.set('price_type', 'Incl');         
        } else {
          $('.template-product .gst-switch #toggle').prop("checked",false);
           Cookies.set('price_type', 'Excl');
        }
  });
$(document).on("click",".gst-switch #toggle",function() {

   if(!this.checked) {
       $('.kg-excluding-price').show();
       $('.kg-including-price').hide();
    }else{
       $('.kg-excluding-price').hide();
       $('.kg-including-price').show();
    }
});

$(document).on("click",".kg-text-with-icons .kg-delivery-icon",function() {
  $(".kg-text-with-icons").toggleClass("kg-cc-elem-show");
});



function sticky_relocate() {
  var window_top = $(window).scrollTop();
  var div_top = $('.product-form__quantity-and-buy-buttons-wrapper').offset().top;
    var aa = $(".header__background-container").height();
    var bb = $(".product-form__quantity-and-buy-buttons-wrapper").height();
    var nn = div_top - aa + bb;
  if (window_top > nn) {
    $('#kg-bottom-card-section').addClass('kg-bottom-sticky');
    $('.product-form__controls-group--submit').addClass('kg-bottom-sticky');
  } else {
    $('#kg-bottom-card-section').removeClass('kg-bottom-sticky');
    $('.product-form__controls-group--submit').removeClass('kg-bottom-sticky');
  }
}

$(function() {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});